import { Link } from "react-router-dom";
import { Linkedin, MapPin, ArrowUpRight } from "lucide-react";
import { Logo } from "@/components/site/Logo";
import { Newsletter } from "@/components/site/Newsletter";
import { OFFICES } from "@/lib/content";

const colTitle = "text-[11px] font-semibold uppercase tracking-[0.18em] text-[color:var(--bp-text-muted)]";
const footLink = "text-[13.5px] text-[color:var(--bp-text-muted)] transition-colors hover:text-[color:var(--bp-teal)]";

export const Footer = () => {
  return (
    <footer className="relative z-10 bg-[color:var(--bp-surface-2)] pt-20" data-testid="global-footer">
      <div className="container-bp">
        <div className="grid grid-cols-1 gap-12 pb-16 md:grid-cols-12">
          <div className="md:col-span-4">
            <Logo />
            <p className="mt-6 max-w-xs text-sm leading-relaxed text-[color:var(--bp-text-muted)]">
              The only banker-founded talent partner covering the full employee lifecycle for private banking in Monaco, Geneva &amp; Paris.
            </p>
            <a
              href="https://www.linkedin.com"
              target="_blank"
              rel="noreferrer"
              className="mt-6 inline-flex items-center gap-2 rounded-full border border-[color:var(--bp-border)] px-4 py-2 text-[12px] text-[color:var(--bp-text-muted)] transition-colors hover:border-[color:var(--bp-teal)] hover:text-[color:var(--bp-teal)]"
            >
              <Linkedin className="h-4 w-4" /> Follow on LinkedIn
            </a>
          </div>

          <div className="md:col-span-2">
            <p className={colTitle}>Services</p>
            <ul className="mt-5 space-y-3">
              <li><Link className={footLink} to="/services/recruitment">Executive Search</Link></li>
              <li><Link className={footLink} to="/services/talent-development">Talent Development</Link></li>
              <li><Link className={footLink} to="/services/consulting">Consulting</Link></li>
              <li><Link className={footLink} to="/services/beyond-partnership">Beyond Partnership</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className={colTitle}>Explore</p>
            <ul className="mt-5 space-y-3">
              <li><Link className={footLink} to="/markets/monaco">Monaco</Link></li>
              <li><Link className={footLink} to="/markets/geneva">Geneva</Link></li>
              <li><Link className={footLink} to="/case-studies">Case Studies</Link></li>
              <li><Link className={footLink} to="/insights">Insights</Link></li>
              <li><Link className={footLink} to="/tools">Tools</Link></li>
              <li><Link className={footLink} to="/about">About</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className={colTitle}>Monaco-Geneva Intelligence</p>
            <p className="mt-5 text-sm leading-relaxed text-[color:var(--bp-text-muted)]">
              Receive our quarterly Talent Barometer and exclusive cross-market briefings.
            </p>
            <div className="mt-4"><Newsletter /></div>
            <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-3">
              {OFFICES.map((o) => (
                <div key={o.city} className="text-[12px] text-[color:var(--bp-text-muted)]">
                  <p className="flex items-center gap-1.5 font-semibold text-[color:var(--bp-cream)]">
                    <MapPin className="h-3.5 w-3.5 text-[color:var(--bp-teal)]" /> {o.city}
                  </p>
                  <p className="mt-1.5 leading-relaxed">{o.phone}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="gold-divider" />
        <div className="flex flex-col items-start justify-between gap-4 py-7 sm:flex-row sm:items-center">
          <p className="text-[12px] text-[color:var(--bp-text-muted)]/80">
            © {new Date().getFullYear()} Beyond Potentials. All rights reserved.
          </p>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
            <Link className="text-[12px] text-[color:var(--bp-text-muted)]/80 hover:text-[color:var(--bp-teal)]" to="/privacy">Privacy</Link>
            <Link className="text-[12px] text-[color:var(--bp-text-muted)]/80 hover:text-[color:var(--bp-teal)]" to="/terms">Terms</Link>
            <Link className="text-[12px] text-[color:var(--bp-text-muted)]/80 hover:text-[color:var(--bp-teal)]" to="/data-retention">Data Retention</Link>
            <Link className="inline-flex items-center gap-1 text-[12px] text-[color:var(--bp-text-muted)]/80 hover:text-[color:var(--bp-teal)]" to="/contact">
              Contact <ArrowUpRight className="h-3 w-3" />
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
